const none = 0
const open = 1
const withCode = 2

class ParentAccess {
    constructor(id) {
        this.id = parseInt("" + id);
    }

    static get none() {
        return none;
    }

    static get open() {
        return open;
    }

    static get withCode() {
        return withCode;
    }

    CopyFromObject(source) {
        this.id = source.id;
    }

    SetFromCode(sourceObj) {
        if (typeof sourceObj === "object")
            this.id = sourceObj.id
    }
};


export default ParentAccess;
